// @flow

import 'react-app-polyfill/ie11'

import * as React from 'react'
// $FlowFixMe
import ReactDOM from 'react-dom'

import * as serviceWorker from './serviceWorker'
import App from './App'

ReactDOM.render(<App />, document.getElementById('root'))

serviceWorker.unregister()
